<script setup lang="ts">
import type { DataTableCellProps } from './templateTypes';

/***
 * template to show concatenated string from combined value
 */
const _rops = defineProps<DataTableCellProps>();
</script>

<template>
  <div>
    {{ cell.meta('combinedValue') }}
  </div>
</template>
